import React, { useState, useEffect } from "react";
import { Container, Form } from "react-bootstrap";
import AccessRequestItem from "../Components/AccessRequestItem/AccessRequestItem";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function AccessRequests() {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [requests, setRequests] = useState([]);
  const [error, setError] = useState("");
  const [checked, setChecked] = useState(false);
  const [filteredRequest, setFilteredRequest] = useState([]);

  const handleAccept = async (requestId) => {
    setError("");
    try {
      const requestToAccept = requests.find((req) => req._id === requestId);

      const [patchResponse, postResponse] = await Promise.all([
        fetch(
          `${process.env.REACT_APP_BACKEND_URL}requests/${requestId}/accept`,
          {
            method: "PATCH",
            credentials: "include",
          }
        ),
        fetch(`${process.env.REACT_APP_BACKEND_URL}user-program-progress/add`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            user: requestToAccept.user._id,
            program: requestToAccept.program._id,
          }),
        }),
      ]);

      const patchdata = await patchResponse.json();

      if (patchResponse.status === 208) {
        setFilteredRequest((prevRequests) =>
          prevRequests.filter((request) => request._id !== requestId)
        );
        filteredRequest.map((f) => {
          if (f._id === requestId) {
            return (f.status = "accepted");
          }
        });
      }

      if (!patchResponse.ok) {
        throw new Error(patchdata.message || t("error_occurred"));
      }

      setFilteredRequest((prevRequests) =>
        prevRequests.filter((request) => request._id !== requestId)
      );
      setRequests((prevRequests) => {
        return prevRequests.map((r) => {
          if (r._id === requestId) {
            return { ...r, status: "accepted" };
          }
          return r;
        });
      });
    } catch (err) {
      setError(err.message || t("error_occurred"));
    }
  };

  const handleReject = async (requestId) => {
    setError("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/requests/${requestId}/reject`,
        {
          method: "PATCH",
          credentials: "include",
        }
      );

      const data = response.json();

      if (!response.ok) {
        throw new Error(data.message || t("error_occurred"));
      }

      setFilteredRequest((prevRequests) =>
        prevRequests.filter((r) => {
          return r._id !== requestId;
        })
      );
      setRequests((prevRequests) => {
        return prevRequests.map((r) => {
          if (r._id === requestId) {
            return { ...r, status: "rejected" };
          }
          return r;
        });
      });
    } catch (err) {
      setError(err.message || t("error_occurred"));
    }
  };

  useEffect(() => {
    setError("");
    const fetchRequests = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/requests`,
          {
            credentials: "include",
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || t("error_occurred"));
        }

        setRequests(data.requests);
        setFilteredRequest(
          data.requests.filter((f) => {
            return f.status === "pending";
          })
        );
      } catch (err) {
        setError(err.message || t("error_occurred"));
      }
    };

    fetchRequests();
  }, []);

  const handleCheck = (e) => {
    setChecked(e.target.checked);
    if (checked === false) {
      setFilteredRequest(requests);
    } else {
      setFilteredRequest(
        requests.filter((req) => {
          return req.status === "pending";
        })
      );
    }
  };

  return (
    <Container>
      <Form className="mb-4">
        <Form.Check
          type="checkbox"
          id="checkbox"
          label={t("see_processed_requests")}
          checked={checked}
          onChange={handleCheck}
        />
      </Form>
      {filteredRequest.length === 0 ? (
        <p className="text-center">{t("no_access_requests")}</p>
      ) : (
        filteredRequest.map((request) => (
          <AccessRequestItem
            handleReject={() => handleReject(request._id)}
            handleAccept={() => handleAccept(request._id)}
            key={request._id}
            request={request}
          />
        ))
      )}
    </Container>
  );
}

export default AccessRequests;
